import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';

export const RelatedResourcesList = styled.div<{ collapse?: boolean }>`
  margin: 0;
  max-height: calc(40px * 25);
  transition: max-height 0.3s linear, margin-bottom 0.1s linear 0.1s;
  overflow: hidden;
  margin-bottom: ${layout.measurements.spacing150};
  ${props =>
    props.collapse
      ? css`
          max-height: 0;
          margin-bottom: 0;
        `
      : null}
`;
